export default __webpack_public_path__ + "static/media/d14.d5dc7944.jpg";